<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Configuracion de Puestos</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>AP_01</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="subtitulos"> Búsqueda de configuración de puestos</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    name="nombre"
                    placeholder="Nombre de la configuracion puesto"
                    v-model="filtro.palabraClave"
                    @keydown.enter.native="obtener"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col></b-col>
            <b-col align="right">
              <b-button
                v-b-tooltip.hover
                title="Agregar configuracion de puesto"
                variant="outline-success"
                v-if="$localStorageService.can('AP_01_admin_alta_puest')"
                @click="agregar()"
                >Agregar puesto
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
            id="configuracion"
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos"
            fixed
          >
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                  v-if="$localStorageService.can('AP_01_admin_mod_puest')"
                  title="Modificar configuracion puesto"
                  size="sm"
                  @click="modificar(row.item)"
                  variant="outline-warning"
                  ><em class="fa fa-pencil"></em
                ></b-button>
                <b-button
                  v-if="
                    !row.item.registroActivo 
                    && $localStorageService.can('AP_01_admin_actv_puest')
                  "
                  title="Activar configuracion puesto"
                  variant="outline-danger"
                  size="sm"
                  @click="activar(row.item)"
                  ><em class="fa fa-undo"></em
                ></b-button>
                <b-button
                  v-else-if="$localStorageService.can('AP_01_admin_baja_puest')"
                  title="Desactivar configuracion puesto"
                  variant="outline-danger"
                  size="sm"
                  @click="desactivar(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show
              >No hay datos</b-alert
            >
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="$registrosPorPaginaTabla"
              aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
    <b-modal v-model="show" :title="tituloModal" size="lg" scrollable>
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="nombre"
                  >Nombre Configuracion
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2" id="nombre">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    name="nombre"
                    placeholder="Nombre del puesto"
                    v-model="$v.configuracionPuesto.configuracion.$model"
                    :state="validateState('configuracion')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Puestos" label-for="idPuestos">
                <v-select
                  style="width: 100%"
                  multiple
                  :options="listaPuestos"
                  :reduce="(item) => item"
                  label="descripcion"
                  placeholder="Selecciona los puestos (*)"
                  id="idPerfiles"
                  v-model="configuracionPuesto.idPuestos"
                >
                  <span slot="no-options">No hay puestos disponibles</span>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <b-button
          ref="submitGuardar"
          type="submit"
          style="visibility: hidden"
        ></b-button>
      </b-form>
      <template v-slot:modal-footer>
        <b-button
          variant="outline-primary"
          @click="submitGuardar"
          :disabled="loaderAcciones"
          v-if="$localStorageService.can('AP_01_admin_alta_puest')"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-danger"
          :disabled="loaderAcciones"
          @click="cerrarModal()"
          >Cancelar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>
<script>
import Header from "../../components/Header";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "configuracionPuesto",
  components: {
    Header,
  },
  mixins: [validationMixin],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      registrosPorPagina: 10,
      paginaActual: 1,
      fields: [
        { key: "idConfiguracionPuesto", label: "ID", sortable: true },
        { key: "nombreConfiguracion", label: "Configuracion", sortable: true },
        { key: "nombrePuesto", label: "Puesto", sortable: true },
        "Acciones",
      ],
      show: false,
      tituloModal: "",
      loaderAcciones: false,
      loader: false,
      configuracionPuesto: {
        configuracion: null,
        idPuestos: [],
      },
      listaPuestos: [],
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null,
      },
    };
  },
  validations: {
    configuracionPuesto: {
      configuracion: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtener();
    this.obtenerPuestos();
  },
  methods: {
    obtener() {
      this.loader = true;
      this.loadingObtener = false;
      this.datosTabla = [];
      this.$http
        .post(this.$api + "catalogos/configuracion/puestos/obtenerPuestos", this.filtro)
        .then((respuesta) => {
          if (respuesta.data.data) {
            respuesta.data.data.forEach((it) => {
              this.paginaActual = 1;
              this.datosTabla.push(it);
            });
          }
        })
        .finally(() => {
          this.loader = false;
          this.loadingObtener = false;
        });
    },
    obtenerPuestos() {
      this.$http.get(this.$api + "catalogos/listaPuestos").then((respuesta) => {
        if (respuesta.data.data) {
          this.listaPuestos = respuesta.data.data;
        }
      });
    },
    submitGuardar() {
      this.$refs.submitGuardar.click();
    },
    guardar() {
      this.loadingGuardar = true;
      if (this.$v.configuracionPuesto.$anyError) {
        return;
      }
      if (!this.$v.configuracionPuesto.$invalid) {
        if (this.configuracionPuesto.idPuestos.length > 0) {
          this.loaderAcciones = true;
          this.$http
            .post(this.$api + "catalogos/configuracion/puestos/guardar", this.configuracionPuesto)
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La configuración se registró correctamente",
                });
                this.filtro.palabraClave = this.configuracionPuesto.configuracion;
                this.obtener();
                this.show = false;
              }
            })
            .catch((error) => {
              console.error(error);
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "La configuración ya existe",
              });
            })
            .finally(() => {
              this.loaderAcciones = false;
            });
        } else {
          this.$swal({
            icon: "error",
            text: "Debe seleccionar al menos un puesto",
          });
        }
      }
    },
    agregar() {
      this.$nextTick(() => {
        this.$v.$reset();
      });
      (this.configuracionPuesto = {
        configuracion: null,
        idPuestos: [],
      }),
        (this.tituloModal = "Agregar configuracion puesto");
      this.show = true;
    },
    cerrarModal() {
      this.show = false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.configuracionPuesto[name];
      return $dirty ? !$error : null;
    },
    desactivar(item) {
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de desactivar la configuracion puesto?",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http
            .delete(
              this.$api +
                "catalogos/configuracion/puestos/desactivar?idConfiguracionPuesto=" +
                item.idConfiguracionPuesto
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.datosTabla[
                  this.datosTabla.indexOf(item)
                ].registroActivo = false;
              }
            });
        }
      });
    },
    activar(item) {
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de activar la configuracion puesto?",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http
            .delete(
              this.$api +
                "catalogos/configuracion/puestos/reactivar?idConfiguracionPuesto=" +
                item.idConfiguracionPuesto
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.datosTabla[
                  this.datosTabla.indexOf(item)
                ].registroActivo = true;
              }
            });
        }
      });
    },
    modificar(item) {
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.configuracionPuesto = JSON.parse(JSON.stringify(item));
      this.tituloModal = "Modificar configuracion puesto";
      this.show = true;
    },
  },
};
</script>
<style scoped>
</style>